import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap';
import './UserDropdown.scss';

export default class UserDropdown extends PureComponent {
  onSelectDealer = (dealer) => {
    this.props.accessDealerRequest(dealer);
  };

  render() {
    const { user, dealers, logout } = this.props;
    if (user) {
      const currentUserDealer = dealers.find((d) => d.id === user.dealer_id);

      return (
        <Dropdown className="dropdown-trigger" id="user-dropdown-basic">
          <Dropdown.Toggle
            className="dropdown-label amp-mask"
            id="user-dropdown-toggle"
            data-dd-privacy="mask"
          >
            {user.firstName} {user.lastName}{' '}
            <span className="dropdown-sub-label">
              {currentUserDealer?.name}
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu className="user-dropdown-menu">
            {user.dealer_id && // can only switch dealerships if logged in as a dealer and not admin
              dealers.length > 1 &&
              dealers.map((d) => (
                <MenuItem key={d.id} onSelect={() => this.onSelectDealer(d)}>
                  {d.name}
                </MenuItem>
              ))}
            <MenuItem onSelect={logout}>Logout</MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      );
    }
    return <div />;
  }
}

UserDropdown.propTypes = {
  user: PropTypes.object,
  dealers: PropTypes.array,
  accessDealerRequest: PropTypes.func,
  logout: PropTypes.func,
};
